import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'x-icon',
  templateUrl: './x-icon.component.html',
  styles: [':host{display: inherit;}']
})
export class XIconComponent implements OnInit {

  @Input() iconColor: string = '#4334EC'
  @Input() width: string = '25px'
  @Input() height: string = '25px'

  constructor() { }

  ngOnInit(): void {
  }

}
